<div class="need-help-card">
    <h2 data-testid="contact-support">Need Help?</h2>
    <p>Call: <a href="tel:{{ phone }}" data-testid="support-contact-number">{{ phone }}</a></p>
    <br />
    <p>Monday - Friday 8 am - 9 pm ET</p>
    <p>Saturday 10 am - 2 pm ET</p>
</div>
